// Shared enums used by both the manual Create Indent form and any other flow
// that mints a ProcurementIndent (e.g. the Replenishment Desk's batch-create
// cart) — kept in one place so the two stay in sync.

export const ASSET_CONDITIONS = ['Brand New', 'Used', 'Refurbished'] as const;
export const ITEM_TYPES = ['GP', 'HC', 'Reefer', 'Dry', 'Blast Freezer', 'Flat Rack', 'ISO Tank', 'Open Top'] as const;
export const SIZES = ['10FT', '20FT', '40FT'] as const;
export const GRADES = [
  'IICL',
  'CW CONDITION - GRADE A - WITHOUT DENT AND PATCH - ADD ALL DETAILS',
  'CW CONDITION - GRADE B',
  'CW CONDITION - GRADE C',
  'CW CONDITION - GRADE D',
  'CW CONDITION - GRADE E',
] as const;
export const PURPOSES = ['Sale', 'Lease', 'Stock', 'Trading'] as const;
export const INDUSTRIES = [
  'Pharma',
  'FMCG',
  'INFRA',
  'F&B / Dairy Products/ Meat Products',
  'Chemical',
  'Defence / Govt',
  'Engineering/ Electronics',
  'Auto Mobile/EV',
  'Logistics',
  'E-Commerce',
  'Manufacturers',
  'Construction',
  'Quatre Agro',
] as const;
export const ACCESSORY_OPTIONS = ['CSC Plate', 'PTI', 'Lock Box', 'GPS', 'Branding', 'Others'] as const;
export const CURRENCIES = ['INR', 'USD', 'EUR', 'AED'] as const;
export const CURRENCY_GLYPH: Record<string, string> = {
  INR: '₹',
  USD: '$',
  EUR: '€',
  AED: 'د.إ',
};

// Cascading Machinery → Sub-Category (codegs.js machineryMap)
export const MACHINERY_MAP: Record<string, string[]> = {
  Daikin: ['LXE', 'Inverter'],
  Carrier: ['Primeline', 'Thinline', 'Eliteline'],
  Thermoking: ['MP 3000', 'MP 4000', 'MP 5000'],
  Starcool: ['Starcool A', 'Starcool B'],
};
export const MACHINERY_OPTIONS = Object.keys(MACHINERY_MAP);

/**
 * Statuses at which there is nothing to attach a serial TO — the vendor round
 * hasn't closed, so no physical container exists yet.
 */
export const PRE_AWARD_STATUSES = [
  'Indent Created',
  'RFQ in Progress',
  'RFQ Completed',
  'Partially Awarded',
] as const;

/**
 * Can container serials be keyed against this indent?
 *
 * Reference parity (index.html `attachEarlyBtn`): gated by STAGE, not by
 * whether a vendor happens to be recorded — an indent can sit at "Advance
 * Requested" with a bid on file but no award written back, which is exactly
 * when serials turn up and someone needs to key them in. Cancelled indents are
 * excluded as no longer active work; a held indent still accepts serials for
 * containers already in transit.
 *
 * Shared by the Control Tower and all three list pages (All Indents, Import
 * Queue, Domestic Queue) so the button can't appear in one and not another.
 */
export function canAttachSerials(indent: { status?: string; lifecycleState?: string } | null | undefined): boolean {
  const status = String(indent?.status || '').trim();
  if (!status) return false;
  if ((PRE_AWARD_STATUSES as readonly string[]).includes(status)) return false;
  return String(indent?.lifecycleState || '').toLowerCase() !== 'cancelled';
}
